import React, { useState, useEffect } from "react"

const GetTimeStamp = function () {
    const [icm, setICM] = useState();
    const [icmTime, setIcmTime] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const icmLink = "https://m.meteo.pl/inowroclaw/60";

    useEffect(() => {
        icmTimeStamp()
    }, []);


    const icmTimeStamp = async () => {

        fetch(icmLink)
            .then(response => {
                if (response.ok) {
                    return response.text();
                }
                throw response
            })
            .then(data => {
                const feed = new window.DOMParser().parseFromString(data, "text/html");
                let pTag = feed.getElementsByClassName("godzinaPogoda")[0].innerHTML;

                let match = pTag.match(/\d.*/);
                let res = match ? match[0] : '';
                setICM(res);
                res = res.substring(0, res.length - 3);
                res = res.replace(/-+/g, '');
                res = res.replace(/\s/g, '');
                setIcmTime(res);
                console.log(res)
            })
            .catch(error => {
                console.error("Error: ", error);
                setError(error);

            })
            .finally(() =>
                setLoading(false));
    }

    if (loading) return "Pobieram.";
    if (error) return "Błąd";

    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
              timestamp: icm
            })
          }, 2000)
    }) 
}

export default GetTimeStamp